import React from 'react';

import PropTypes from 'prop-types';

import styles from './SectionTitle.scss';

function SectionTitle(props) {
    const {
        children,
        className = '',
        ...otherProps
    } = props;

    return (
        <h2
            aria-level="2"
            className={`${styles.sectionTitle} ${className}`}
            role="heading"
            {...otherProps}
        >
            {children}
        </h2>
    );
}

SectionTitle.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export default SectionTitle;
